<template>
  <div class="projects min-width">
    <div class="text header">MY PROJECTS</div>

    <!-- Projects list -->
    <project
      v-for="(project, index) in this.projects.filter(proj => proj.visible ==  true)"
      :key="index"
      :name="project.name"
      :description="project.description"
      :role="(project.role ? project.role : null)"
      :challenges="(project.challenges ? project.challenges : null)"
      :features="(project.features ? project.features : null)"
      :technologies="(project.technologies ? project.technologies : null)"
      :preview="project.img"
      :year="project.year"
      :month="project.month"
      :platform="project.platform"
      :decorate="project.decorate"
      :links="project.links"
      :reverse="shouldReverse(index)"
    />
  </div>
</template>

<script>
import Project from "@/components/Project.vue";

export default {
  name: "projects",
  components: {
    Project
  },
  data() {
    return {
      projects: [
        {
          name: "Auction Sim",
          month: 4,
          year: 2020,
          description:
            "This is a project I am working on solely for fun. Its an auction simluator meant to simulate an auction website ala Ebay. It consists of psuedo-users buying, selling, and bidding on each other's items. Using the app, you can make an account and participate in this virtual economy and watch these pseudo-users as they interact with each other in real-time. ",
          features: [
            "On-going simulated buying, selling, and bidding",
            "Unique User Personalities",
            "Real-time bidding updates"
          ],
          challenges:
            "The goal of this project was to introduce myself to websockets and real-time data handling. I wanted to build a virtual platform that real users can interact with see what's happening in real-time.",
          technologies: [
            "nodejs",
            "nativescript",
            "vuejs",
            "mongodb",
            "ASP.NET",
            "signalr",
            "github"
          ],
          img: "auction-sim-browse-1.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "github",
              address: "https://github.com/Reybel24/auction-sim-mobile"
            },
            { platform: "ios-app", msg: "Coming soon" },
            { platform: "android-app", msg: "Coming soon" }
          ],
          decorate: true
        },
        {
          name: "Windows X",
          month: 7,
          year: 2020,
          description:
            "If you've ever wanted to use an incredibly stripped down version of windows that occasionally breaks, now you can. This is a project I've put a lot of effort and passion into. I wanted to create an 'OS in your browser' experience and got to work creating a 'clone' of Windows 10 and even painstakingly re-created some popular apps (with partial functionality).",
          features: [
            "Looks like windows",
            "Various apps (like Spotify and Firefox)",
            "Functional File Explorer",
            "Very draggable desktop icons",
            "Functional terminal"
          ],
          challenges:
            "Working on this project required me to think differently than what I'm used to. For example, I had to think less 'web' and more 'operating system' to try to emulate some of Windows' functions like launching and closing apps, data structures, and process management. I was introduced to various new programming concepts as I worked through these challenges that will undoubtedly carry over to future projects. ",
          technologies: [
            "nodejs",
            "vuejs",
            "javascript",
            "trello",
            "github"
          ],
          img: "windows-x-desktop-1.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "github",
              address: "https://github.com/Reybel24/Windows-X"
            },
            {
              platform: "website",
              address: "https://windows-x.com"
            }
          ],
          decorate: true
        },
        {
          name: "pullup",
          month: 2,
          year: 2020,
          description:
            "pullup is a mobile application aimed at facilitating the tedius task of finding parking spaces in densely populated areas. The app was ported over from Java/Swift to React Native.",
          role:
            "Working in a small team, my role was mainly as middle-ware/back-end developer. While I worked on the front-end design and implemented several pages, I primarily focused on the middleware to enable the app to talk to the back-end and worked with the already existing back-end of the app.",
          features: [
            "Real-time car tracking",
            "Stripe Integration",
            "Lookup of available spots"
          ],
          technologies: [
            "nodejs",
            "reactjs",
            "python",
            "sql",
            "webpack",
            "stripe"
          ],
          img: "pullup-side-by-side.png",
          visible: true,
          platform: "web",
          links: [
            { platform: "ios-app", msg: "Coming soon" },
            { platform: "android-app", msg: "Coming soon" }
          ]
        },
        {
          name: "Unit Testing Dashboard",
          month: 11,
          year: 2019,
          description:
            "For this project, I developed a robust unit-testing dashboard for the purposes of managing and running internal custom-scripted unit tests. This front-end dashboard served as an update to the company's previous unit-testing system that consisted of running the unit tests through a command line.",
          role:
            "Working as a one-man team, I developed the front-end in VueJS and the back-end in Python. I also developed an API with Python Flask to talk to the back end and wrote its documentation.",
          challenges:
            "This was my first time working with Flask to develop any type of API and there was a ton to learn. I completely re-wrote my API several times as I learned best practices and better techniques. Additionally, while I had dabbled with VueJS before, I had never really dug too in-depth with it and so going from that to developing a full-blown data-driven web app using it was a tremendous challenge. Overall a very fun project and the experience I earned from it is invaluable.",
          features: [
            "In-Depth Analytics",
            "Run tests from web",
            "Manage tests (add, delete, edit)",
            "View progress of tests as they run",
            "History",
            "Automatic Unit Test Creation"
          ],
          technologies: [
            "nodejs",
            "vuejs",
            "python",
            "sql",
            "webpack",
            "flask",
            "docker",
            "gitlab",
            "trello"
          ],
          img: "unit-testing-dashboard-1.png",
          visible: true,
          platform: "web"
        },
        {
          name: "E-Commerce Website",
          month: 4,
          year: 2020,
          description:
            "This was a project where the goal was to create an online shopping website that includes product data stored in a database, a shopping cart, and a checkout page.",
          role:
            "My primary role was the front-end design, but I worked extensively in the back-end of the app as well to bring together the API and the data needed in the front-end. Additionally, I developed functionality for user reviews and related products.",
          challenges:
            "Being the first time I had worked on an e-commerce website, I initially found it difficult to find a good balance between data density and simplicity in regards to the amount of content to show a potential customer.",
          features: [
            "Completely Data-driven",
            "Recommend Similar Products",
            "Shopping Cart",
            "Stripe Integration"
          ],
          technologies: [
            "nodejs",
            "vuejs",
            "php",
            "sql",
            "webpack",
            "github",
            "trello"
          ],
          img: "caps-locker-1.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "website",
              address: "https://www.socknmonkey.com/#/products"
            },
            {
              platform: "github",
              address: "https://github.com/Reybel24/IT310_E-Commerce"
            }
          ]
        },
        {
          name: "Simvestor",
          month: 10,
          year: 2019,
          description:
            "A group project where the goal was to develop some web application that heavily uses an API. My team and I created an investment based around cryptocurrency simulator where users can invest their pseudo-money in a simulated environment.",
          role:
            "I developed the front-end in VueJS and wrote the API calls to our back-end server. Additionally, I wrote a lot of the logic in our back-end to handle our API requests to retrieve data from our databases through RabbitMQ.",
          challenges:
            "This project presented its fair share of difficulties. One of the biggest ones was RabbitMQ. Having never used RabbitMQ before, I seriously struggled at first diving head-first into this project. It wasn't until my team and I took a step back to really understand the technology and what its doing that we were able to move forward successfully.",
          features: [
            "User Profiles",
            "Real Crypto prices from API",
            "Ability to invest/sell",
            "Portfolio Evaluations"
          ],
          technologies: [
            "nodejs",
            "vuejs",
            "rabbitmq",
            "php",
            "python",
            "sql",
            "webpack",
            "trello"
          ],
          img: "simvestor-0.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "github",
              address: "https://github.com/Reybel24/IT490-InvestmentSimulator"
            }
          ]
        },
        {
          name: "Emulated Terminal",
          month: 3,
          year: 2020,
          description:
            "This is that terminal you see up there in the introduction. I really enjoyed working on this and am continuously adding new commands to it. If you haven't given it a whirl, go ahead and play around with it a bit.",
          features: [
            "Complex command parsing w/ multiple arguments",
            "Looks (sorta) just like the real thing"
          ],
          technologies: ["nodejs", "vuejs", "javascript", "webpack"],
          img: "terminal-0.png",
          visible: true,
          platform: "web",
          decorate: false
        },
        {
          name: "Social Media Simulator (WIP)",
          month: 2,
          year: 2020,
          description:
            "This is a project I worked on solely for fun. I built a 'social simulator' where you can watch pseudo-users post, comment, like, and interact with each other in real time.",
          features: [
            "Simulated Content Generation",
            "Unique User Personalities",
            "Real-time interaction",
            "Post/Comment System"
          ],
          challenges:
            "One of the biggest challenges I ran into with this project was figuring out how to go about generating unique content that somewhat feels like it could be something posted by a real user. This is no easy feat, and I ended up taking a markov chain approach to produce sentences that weren't total gibberish.",
          technologies: [
            "nodejs",
            "vuejs",
            "python",
            "sql",
            "webpack",
            "ASP.NET",
            "github",
            "trello"
          ],
          img: "social-sim.png",
          visible: false,
          platform: "mobile",
          links: [
            { platform: "website", msg: "Coming soon" },
            {
              platform: "github",
              address: "https://github.com/Reybel24/vue-social-sim"
            }
          ]
        },
        {
          name: "New York Education Analytics",
          month: 5,
          year: 2019,
          description:
            "This was a group project where the objective was to present data about New York's education system and help the user discover hidden links within seemingly unrelated datasets.",
          role:
            "I took the role of front-end developer and developed the front-end dealing with data visualization. I facilitated the task of adding data by creating a script that reads information from a JSON file containing our metadeta. The script takes this metadata, fetches the appropriate data from the NYC API, then creates viewable data with this (complete with charts using ChartJS). The script parses the data and formats it before feeding it into ChartJS. Additionally, I created a simple suggestion system to suggest related datasets.",
          challenges:
            "Figuring out the best way of displaying such large amounts of data is never easy and is something our team struggled with. Ultimately, we did not have enough time to improve the UI in a way that would allow for the data to be read easier and is something I wish we could have gotten to.",
          features: [
            "Real Data from API",
            "Data Visualization with ChartJS",
            "Related recommendations"
          ],
          technologies: ["html", "php", "javascript", "php", "git", "trello"],
          img: "brick-city-1.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "github",
              address: "https://github.com/Reybel24/IS247Final-BrickCity"
            }
          ]
        },
        {
          name: "Avent",
          month: 5,
          year: 2018,
          description:
            "A design prototype for a mobile design course. Avent is an online social platform where people can post, discover, and share activites happening around them.",
          technologies: ["unity", "photoshop"],
          img: "avent.png",
          visible: true,
          platform: "mobile"
        },
        {
          name: "Animal Laboratory",
          month: 8,
          year: 2018,
          description:
            'More of a passion project, Animal Laboratory is a mobile "idle" game in which players purchase increasingly advanced labs and unlock new animals as they progress. The ultimate goal of the game is to grow your lab as large as possible and produce extraordinary amounts of money.',
          challenges:
            "Being my first serious dive into Unity and C#, this was an uphill battle the entire way. Every step of the way required me to learn more about the systems Unity uses. There were many refactors, rewrites, redesigns, and re-do's.",
          technologies: ["unity", "C#", "github", "trello"],
          img: "animal-lab-2.png",
          visible: true,
          platform: "mobile",
          links: [
            { platform: "android-app", msg: "Coming soon" },
            { platform: "ios-app", msg: "Coming soon" }
          ]
        },
        {
          name: "Tap Tap Royale",
          month: 8,
          year: 2019,
          description:
            'This is my second game. I aimed to merge the clicker and battle royale genre somewhat by creating a game in which users try to defeat each other using weapons they "pick up". You tap an oppenent to attack them and doing so depletes their coins.',
          features: ["Real-time multiplayer", "In-app Purchases"],
          technologies: ["unity", "C#", "github", "trello"],
          img: "tap-tap-royale-min.png",
          visible: true,
          platform: "mobile",
          links: [
            { platform: "android-app", msg: "Coming soon" },
            { platform: "ios-app", msg: "Coming soon" }
          ]
        },
        {
          name: "Twodo",
          month: 4,
          year: 2018,
          description:
            "This was a simple project where the goal was to create a to-do list web app. Users can egister and login and manage their lists. This project involved me and a partner.",
          role:
            "I designed and implemented the login screen, as well as a large portion of the back-end system, including sign-in and registraion. Additionally, I developed the majority of the to-do system.",
          technologies: ["html", "php", "sql"],
          img: "twodo.png",
          visible: true,
          platform: "web",
          links: [
            {
              platform: "github",
              address: "https://github.com/RichardFebres/is218p1"
            }
          ]
        },
        {
          name: "Browser Terminal",
          month: 7,
          year: 2015,
          description:
            "This was my attempt to emulate a functional terminal within a web browser. It has several functional commands such as echo, net user, history, color, and others. ",
          challenges:
            "This was my first real dive into using javascript along my webpages and I was not nearly as fluent at it as I am now. The main challenge was taking the user input, which may be complex and involve various commands and arguments, and parsing it to produce the appropriate output. This project presented several challenges involving information formatting and display as well.",
          technologies: ["html", "javascript"],
          img: "cmd.png",
          visible: true,
          platform: "web"
        },
        {
          name: "Creature Cove (Under Development)",
          month: 3,
          year: 2020,
          description:
            "Creature Cove is a card-game where players build their decks throughout each round and take turns attacking each other. The player with atleast one remaining creature at the end of the round wins.",
          challenges:
            "As a game done in VueJS, this project required me to learn about animations on the web, something I've never really delve too deap into before.",
          technologies: ["nodejs", "vuejs", "c#", "github", "trello"],
          img: "creature-cove-min.png",
          visible: false,
          platform: "web",
          links: [{ platform: "website", msg: "Coming soon" }]
        }
      ]
    };
  },
  methods: {
    // Returns whether or not a project should be "reversed"
    shouldReverse(index) {
      if (index % 2 == 0) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
.projects {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #2b2a3f;
  align-items: center;
}
.header {
  padding: 43px;
}
</style>
